import { RootState } from "@/shared/types";
import { IChatsData, IGetManyChatsParams } from "./types/interfaces";

export const selectChats = (state: RootState): IChatsData =>
  state.chats.data;

export const selectParams = (state: RootState): IGetManyChatsParams =>
  state.chats.params;
